module.exports = __webpack_public_path__ + "img/block31.8d80fefe.jpg";